import mod from "-!./gallery.js?vue&type=script&lang=js&"; export default mod; export * from "-!./gallery.js?vue&type=script&lang=js&"